import { type AggregatedMetrics } from '@prerender/prerender-shared/FE';
import groupByTime from '../groupByTime';

import { crawlerType as crawlerTypeFor, type CrawlerType } from '~features/crawler-filter';

// same response from pages crawled chart
function parseCrawlerTypeRawData(response: AggregatedMetrics.PagesCrawledResult) {
  const groupedByTime = groupByTime<AggregatedMetrics.PagesCrawledResult>(response);
  const typesValues: Record<string, number[]> = {};

  const totalRequestsPerType: Partial<Record<CrawlerType, number>> = groupedByTime.reduce<
    Partial<Record<CrawlerType, number>>
  >((acc, item) => {
    item.data.forEach((datapoint) => {
      const type = crawlerTypeFor(datapoint.crawler);
      acc[type] = (acc[type] || 0) + datapoint.total_o_count;

      if (!typesValues[type]) typesValues[type] = Array(response.intervals.length).fill(0); // saves a loop
    });
    return acc;
  }, {});

  groupedByTime.forEach((item, index) => {
    item.data.forEach((datapoint) => {
      const type = crawlerTypeFor(datapoint.crawler);
      typesValues[type][index] = (typesValues[type][index] || 0) + datapoint.total_o_count;
    });
  });

  const sortedTotalRequestsPerTypeAsList: [CrawlerType, number][] = Object.entries(totalRequestsPerType).sort(
    (a, b) => {
      const valueA = a[1] as number;
      const valueB = b[1] as number;
      return valueB - valueA;
    }
  ) as [CrawlerType, number][];

  const sortedCrawlerTypesValuesList = Object.entries(
    sortedTotalRequestsPerTypeAsList.reduce<Record<string, number[]>>((acc, crawlerType) => {
      acc[crawlerType[0]] = typesValues[crawlerType[0]];
      return acc;
    }, {})
  );

  return {
    totalRequestsPerType: sortedTotalRequestsPerTypeAsList,
    typesValues: sortedCrawlerTypesValuesList,
  };
}

export default parseCrawlerTypeRawData;
